(() => {
  const sections = document.querySelectorAll('[data-bud-acid-fruits]');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const hands = Array.from(section.querySelectorAll('[data-bud-acid-hand]'));
    let frame = null;
    let mobileFrame = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    let isActive = false;
    let enterTimer = null;

    const render = () => {
      currentX += (targetX - currentX) * 0.1;
      currentY += (targetY - currentY) * 0.1;

      hands.forEach((hand) => {
        const depthX = Number(hand.dataset.depthX || 0);
        const depthY = Number(hand.dataset.depthY || 0);
        const depthRot = Number(hand.dataset.depthRot || 0);
        const side = hand.dataset.side;
        let x = currentX * depthX;
        let y = currentY * depthY;

        if (side === 'left') x = Math.min(x, 5);
        if (side === 'right') x = Math.max(x, -5);
        x = Math.max(-16, Math.min(16, x));
        y = Math.max(-8, Math.min(8, y));

        hand.style.setProperty('--bud-acid-x', `${x.toFixed(2)}px`);
        hand.style.setProperty('--bud-acid-y', `${y.toFixed(2)}px`);
        hand.style.setProperty('--bud-acid-rot', `${(currentX * depthRot).toFixed(3)}deg`);
      });

      if (Math.abs(targetX - currentX) > 0.002 || Math.abs(targetY - currentY) > 0.002) {
        frame = requestAnimationFrame(render);
      } else {
        frame = null;
      }
    };

    const start = () => {
      if (!frame) frame = requestAnimationFrame(render);
    };

    const startMobileLoop = () => {
      if (!mobileQuery.matches || prefersReducedMotion || mobileFrame) return;

      const loop = (time) => {
        if (!isActive || !mobileQuery.matches) {
          mobileFrame = null;
          return;
        }

        const t = time / 1000;
        targetX = Math.sin(t * 0.78) * 0.78 + Math.sin(t * 1.36) * 0.18;
        targetY = Math.cos(t * 0.92) * 0.5;
        start();
        mobileFrame = requestAnimationFrame(loop);
      };

      mobileFrame = requestAnimationFrame(loop);
    };

    const stopMobileLoop = () => {
      if (!mobileFrame) return;
      cancelAnimationFrame(mobileFrame);
      mobileFrame = null;
    };

    const resetMotion = () => {
      targetX = 0;
      targetY = 0;
      currentX = 0;
      currentY = 0;
      hands.forEach((hand) => {
        hand.style.setProperty('--bud-acid-x', '0px');
        hand.style.setProperty('--bud-acid-y', '0px');
        hand.style.setProperty('--bud-acid-rot', '0deg');
      });
    };

    const activate = () => {
      if (isActive) return;
      isActive = true;
      resetMotion();
      section.classList.add('bud-acid-fruits--active', 'bud-acid-fruits--entering');

      if (enterTimer) window.clearTimeout(enterTimer);
      enterTimer = window.setTimeout(() => {
        section.classList.remove('bud-acid-fruits--entering');
        enterTimer = null;
      }, 1080);
      startMobileLoop();
    };

    const deactivate = () => {
      if (!isActive) return;
      isActive = false;
      stopMobileLoop();
      if (enterTimer) {
        window.clearTimeout(enterTimer);
        enterTimer = null;
      }
      resetMotion();
      section.classList.remove('bud-acid-fruits--active', 'bud-acid-fruits--entering');
      start();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio > 0.18) activate();
            else deactivate();
          });
        },
        { threshold: [0, 0.18, 0.36] }
      );
      observer.observe(section);
    } else {
      activate();
    }

    if (!prefersReducedMotion) {
      section.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch' || !isActive || mobileQuery.matches) return;

        const rect = section.getBoundingClientRect();
        targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        start();
      });

      section.addEventListener('pointerleave', () => {
        if (mobileQuery.matches) return;
        targetX = 0;
        targetY = 0;
        start();
      });
    }
  });
})();
